import { Link } from 'react-router-dom'
import { TOOL_LINKS } from '../../content/tools'
import { ROUTES } from '../../lib/routes'

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-slate-950/70">
      <div className="mx-auto grid max-w-6xl gap-10 px-4 py-12 sm:px-6 lg:px-8 md:grid-cols-3">
        <div className="space-y-3">
          <div className="text-base font-semibold tracking-tight text-white">PDF Agora</div>
          <p className="text-sm text-slate-300">Ferramentas PDF rápidas e privadas, diretamente no seu navegador.</p>
          <p className="text-xs text-slate-400">
            Use por sua conta e risco. Sempre revise os resultados antes de confiar neles. Ao usar este serviço, você reconhece que não somos responsáveis por erros ou danos. Consulte nossos Termos de Serviço para mais detalhes.
          </p>
        </div>

        <div className="grid gap-2 text-sm text-slate-300 md:col-span-2 md:grid-cols-2">
          <div className="space-y-2">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">Ferramentas</div>
            <ul className="grid gap-1">
              <li>
                <Link to={ROUTES.tools} className="hover:text-white font-medium">
                  Todas as Ferramentas
                </Link>
              </li>
              {TOOL_LINKS.map((t) => (
                <li key={t.href}>
                  <Link to={t.href} className="hover:text-white">
                    {t.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          <div className="space-y-2">
            <div className="text-xs font-semibold uppercase tracking-wide text-slate-400">Empresa</div>
            <ul className="grid gap-1">
              <li>
                <Link to={ROUTES.about} className="hover:text-white">
                  Sobre
                </Link>
              </li>
              <li>
                <Link to={ROUTES.privacy} className="hover:text-white">
                  Política de privacidade
                </Link>
              </li>
              <li>
                <Link to={ROUTES.terms} className="hover:text-white">
                  Termos de serviço
                </Link>
              </li>
            </ul>
            <div className="pt-4 text-xs text-slate-500">© {new Date().getFullYear()} PDF Agora</div>
          </div>
        </div>
      </div>
    </footer>
  )
}
